export const NESTED_METRIC_SEPARATOR = '/';